export default "__VITE_ASSET__03qk6QoR__"